export enum IStatus {
  All = '',
  Pending = 'pending',
  PendingPayment = 'pending-payment',
  Review = 'review',
  Process = 'process',
  Allocated = 'allocated',
  Open = 'open',
  Default = 'default',
  InProgress = 'progress',
  Closed = 'closed',
  Active = 'active',
  Inactive = 'inactive',
  Expired = 'expired',
  Canceled = 'canceled',
  Unfinalised = 'unfinalised',
}
